export const ROOT_HTML_ID = "solo-platform-root";
